import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import PopoverLayout from './popover_layout'
import List from '../list'
import { CX } from '../../constants'

class ReplyGroupPopover extends ImmutablePureComponent {
  handleOnClick(replyGroup) {
    const { onClose, onReplyGroupChange } = this.props
    onReplyGroupChange && onReplyGroupChange(replyGroup)
    onClose()
  }

  render() {
    const { isXS, onClose } = this.props

    const items = []
    const replyGroups = [{ key: 'all', name: 'Everyone' }, { key: 'pro', name: 'Pro/Verified' }, { key: 'none', name: 'No Replies' }]

    replyGroups.forEach((replyGroup) => {
      items.push({
        hideArrow: true,
        title: replyGroup.name,
        onClick: () => this.handleOnClick(replyGroup.key)
      })
    })

    const listWrapperStyles = CX({
      d: 1,
      maxH340PX: !isXS,
      overflowYScroll: !isXS
    })

    return (
      <PopoverLayout width={320} isXS={isXS} onClose={onClose}>
        <div className={listWrapperStyles}>
          <List size={isXS ? 'large' : 'normal'} items={items} title="Who can reply?" />
        </div>
      </PopoverLayout>
    )
  }
}

ReplyGroupPopover.propTypes = {
  isXS: PropTypes.bool,
  onClose: PropTypes.func,
  onReplyGroupChange: PropTypes.func,
  selectedReplyGroupId: PropTypes.string,
  groupId: PropTypes.string,
  replyGroups: ImmutablePropTypes.list,
}

export default ReplyGroupPopover
